import { createSlice } from "@reduxjs/toolkit";
import summaryApi from "../configurator/services/summaryApi";
import {setReadyToSave} from "./configuratorStateSlice";

export const summarySlice =  createSlice({
    name: 'summary',
    initialState: {
        summaryLoading: 'idle',
        catalog_number: '',
        leg_catalog_numbers: '',
        price: '',
        total_price: '',
        quickship: false,
        is_invalid: false,
        element_summary: [],
        sections: [],
        shapes: []
    },
    reducers: {
        summaryLoading(state, action) {
            if (state.summaryLoading === 'idle') {
                state.summaryLoading = 'pending'
            }
        },
        summaryLoaded(state, action) {
          if(state.summaryLoading === 'pending') {
              state.summaryLoading = 'idle'
          }
        },
        summaryReceived(state, action) {
                state.catalog_number = action.payload.catalog_number;
                state.price = action.payload.price;
                state.total_price = action.payload.total_price;
                state.quickship = action.payload.quickship;
                state.is_invalid = action.payload.is_invalid;
                state.summaryLoading = 'idle';
        },
        patternSummaryReceived(state, action) {
            state.catalog_number = action.payload.pattern_catalog_number;
            state.price = action.payload.price;
            state.total_price = action.payload.total_price;
            state.quickship = action.payload.quickship;
            state.is_invalid = action.payload.is_invalid;
            state.leg_catalog_numbers = action.payload.leg_catalog_numbers;
            state.summaryLoading = 'idle';
        },
        elementSummaryReceived(state, action) {
            if(state.summaryLoading === 'idle'){
                state.catalog_number = action.payload.catalog_number;
                state.price = action.payload.price;
                state.total_price = action.payload.total_price;
                state.quickship = action.payload.quickship;
                state.is_invalid = action.payload.is_invalid;
                state.element_summary = action.payload.element_summary;
                state.sections = action.payload.sections;
                state.shapes = action.payload.shapes;
            }
        },
    }
});
export const { summaryLoading, summaryReceived, patternSummaryReceived, elementSummaryReceived, summaryLoaded } = summarySlice.actions;

export const getSummary = () => async (dispatch, getState) => {
    const state = getState();
    dispatch(setReadyToSave(false));
    const data = await summaryApi.getSummary(state.productDataReducer, state.projectDetailsReducer.currency, state.projectDetailsReducer.quantity)
    dispatch(summaryReceived(data.summary))
    dispatch(setReadyToSave(true));
    // returns summary data if needed
    return data.summary;
}

export const getPatternSummary = () => async (dispatch, getState) => {
    dispatch(summaryLoading());
    dispatch(setReadyToSave(false));
    const state = getState();
    const patternId = state.patternDetailsReducer.patternId;
    const patternCode = state.patternDetailsReducer.patternCode;
    const currency = state.projectDetailsReducer.currency;
    const quantity = state.projectDetailsReducer.quantity;

    const productData = Object.assign({}, state.productDataReducer, {
       pattern_code: patternCode
    });
    const data = await summaryApi.getPatternSummary(productData, currency, quantity, patternId, patternCode);
    dispatch(patternSummaryReceived(data.patternSummary));
    dispatch(setReadyToSave(true));
}

export const getElementSummary = () => async (dispatch, getState) => {
    dispatch(summaryLoading());
    dispatch(setReadyToSave(false));
    const state = getState();
    const elements_with_selections = state.productElementsReducer.elements_with_selections;
    const cleanElements = [];
    for(const element of elements_with_selections) {
        const cleanElement = Object.assign({}, element, {
            attribute_selections: element.attribute_selections.filter(as => !as.read_only && as.selection)
        })
        cleanElements.push(cleanElement);
    }
    const productData = Object.assign({}, state.productDataReducer, {
        elements_with_selections: cleanElements
    });
    const data = await summaryApi.getElementSummary(productData, state.projectDetailsReducer.currency, state.projectDetailsReducer.quantity);
    dispatch(summaryLoaded())
    dispatch(elementSummaryReceived(data.summary));
    dispatch(setReadyToSave(true));
};

const reducer = summarySlice.reducer;
export default reducer